export default __webpack_public_path__ + "static/media/working_square.b5d57629.jpg";